import { useQuery } from '@tanstack/react-query';
import { getLatestRepositoryConfig } from 'Services';
import { RQ_LATEST_REPOSITORY_CONFIG } from 'Utils';

function useGetLatestRepositoryConfig() {
    return useQuery([RQ_LATEST_REPOSITORY_CONFIG], () => getLatestRepositoryConfig());
}
export default useGetLatestRepositoryConfig;
